import React, {
  createContext,
  PropsWithChildren,
  ReactElement,
  useContext,
} from 'react';

import {
  LogDataFormGroupProps,
  UnitNode,
} from '@/components';
import {
  RaffleEntryResponse,
  RaffleGroupDetail,
  RepresentativeRaffleEvent,
} from '@/editorComponents/Raffle/types';

export interface RaffleContextValue {
  /**
   * 래플 버튼 CTA 클릭시 실행되는 event입니다.
   */
  onClick?: (groupId: string) => Promise<void> | void;
  /**
   * 대표 래플 이벤트를 조회합니다.(유저향)
   * @param groupId 래플 이벤트 그룹 id
   * @param displayDate 표시 날짜 (어드민에서 특정 날짜 기준으로 미리보기)
   * @returns 조회된 래플 이벤트
   */
  getRaffleEvent?: (
    groupId: string,
    displayDate?: Date,
  ) => Promise<RepresentativeRaffleEvent> | RepresentativeRaffleEvent;
  /**
   * 래플 그룹 상세 정보를 조회합니다.(어드민향)
   * @param groupId 래플 이벤트 그룹 id
   * @returns 래플 그룹 및 이벤트 목록
   */
  getRaffleGroup?: (groupId: string) => Promise<RaffleGroupDetail> | RaffleGroupDetail;
  /**
   * 래플 이벤트에 참여합니다.(유저향)
   * @param eventId 래플 이벤트 id
   * @returns 참여 결과
   */
  postRaffleEntry?: (eventId: string) => Promise<RaffleEntryResponse | null> | RaffleEntryResponse;
  /**
   * 로그 데이터를 custom할 때 사용합니다.
   * */
  setLogData?: (unitNode: UnitNode) => LogDataFormGroupProps;
}

const RaffleContext = createContext<RaffleContextValue>({});
export const useRaffleContext = (): RaffleContextValue => useContext(RaffleContext);

export function RaffleContextProvider({
  children,
  value = {},
}: PropsWithChildren<{ value?: RaffleContextValue }>): ReactElement {
  return (
    <RaffleContext.Provider value={value}>
      { children }
    </RaffleContext.Provider>
  );
}
